export const filterPostalCode = (value?: string) => {
  if (!value) return ''
  value = value.toString()
  return value.substr(0, 2) + '-' + value.substr(2)
}
